export type WikiSearchItem = {
  id: string;
  kind: 'hero' | 'guide' | 'community';
  title: string;
  description: string;
  meta: string;
  href: string;
};

type WikiSearchResponse = {
  items?: WikiSearchItem[];
  total?: number;
  error?: string;
};

const SEARCH_LIMIT = 40;

export async function fetchWikiSearch(
  gameKey: string,
  query: string,
  signal?: AbortSignal,
  limit = SEARCH_LIMIT,
): Promise<WikiSearchItem[]> {
  const keyword = query.trim();
  if (!keyword) return [];
  const params = new URLSearchParams({
    q: keyword,
    limit: String(Math.min(Math.max(limit, 1), 50)),
  });
  const response = await fetch(
    `/api/games/${encodeURIComponent(gameKey)}/search?${params}`,
    { signal, cache: 'no-store' },
  );
  const payload = (await response.json()) as WikiSearchResponse;
  if (!response.ok) {
    throw new Error(payload.error || '搜索失败');
  }
  return (payload.items || []).map((item) => ({
    ...item,
    kind:
      item.kind === 'hero' || item.kind === 'guide' || item.kind === 'community'
        ? item.kind
        : 'community',
    title: item.title || '未命名内容',
    description: item.description || '',
    meta: item.meta || '',
    href: item.href || '#',
  }));
}
